<template>
  <div class="w-full flex flex-row bg-neutral-700">
    <div class="w-full h-[44px] md:h-[72px] mx-4 my-10 md:my-6 px-2 md:px-7 flex flex-row justify-between">
      <div class="w-full flex flex-row gap-4 items-center">
        <RouterLink :to="{ name: 'home' }">
          <Logo class="h-10 [pointer-events:bounding-box] [&_g]:transition-[fill] [&_g]:duration-300 hover:[&_g]:[fill:#33cccc]" />
        </RouterLink>
        <div class="flex-grow">
          &nbsp;
        </div>
        <PublisherSwitcher v-if="mounted && userStore.isLoggedIn && breakpoints.greaterOrEqual('md').value" class="flex-shrink-0" />
        <div v-if="!mounted || !userStore.isLoggedIn" class="hidden md:flex flex-row gap-4 items-center flex-shrink-0">
          <VaButton :to="{ name: 'login' }" size="large" plain>
            {{ t('header.login') }}
          </VaButton>
          <VaButton :to="{ name: 'register' }" size="large" preset="secondary" color="primary" border-color="primary">
            {{ t('header.register') }}
          </VaButton>
        </div>
        <div class="flex flex-shrink-0" :class="{ 'md:hidden': !mounted || !userStore.isLoggedIn }">
          <VaButton
            size="large"
            preset="secondary"
            icon="menu"
            @click="userStore.showSidebar"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { VaButton } from 'vuestic-ui'
import Logo from '@/assets/images/logo.svg'
import { useUserStore } from '@/stores/UserStore'
import PublisherSwitcher from '@/components/PublisherSwitcher.vue'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

const breakpoints = useBreakpoints(breakpointsTailwind)
const userStore = useUserStore()
const { t } = useI18n()

// Gates the logged-in chrome. false during SSR and the client's first
// (hydration) render; the token comes from a persisted store the server cannot
// see, so branching on it during hydration mismatches.
const mounted = ref(false)
onMounted(() => {
  mounted.value = true
})
</script>
